document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("subscription-popup");
  if (!popup) return;

  const overlay = popup.querySelector(".fixed-overlay");
  const closeBtn = popup.querySelector(".popup__close-btn");

  const COOKIE_NAME = "promopopup";
  const HOURS = 24;

  // Read config from data attributes
  const triggerMode = popup.getAttribute("data-trigger-open") || "immediately";
  const delaySeconds = parseInt(popup.getAttribute("data-delay-seconds"), 10) || 5;
  const scrollPercent = parseInt(popup.getAttribute("data-scroll-percent"), 10) || 25;

  // --- Cookie helpers ---
  function setCookie(name, value, hours) {
    const now = new Date();
    now.setTime(now.getTime() + hours * 60 * 60 * 1000);
    document.cookie = name + "=" + value + "; expires=" + now.toUTCString() + "; path=/";
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  }

  // --- Show / Hide ---
  let popupShown = false;

  function showPopup() {
    if (popupShown) return;
    popupShown = true;
    popup.classList.add("open");
    document.body.classList.add("active-popup");
    // Clean up scroll listener if it was attached
    window.removeEventListener("scroll", onScroll);
  }

  function hidePopup() {
    popup.classList.remove("open");
    document.body.classList.remove("active-popup");
    setCookie(COOKIE_NAME, "hidden", HOURS);
  }

  // --- Scroll helper ---
  function getScrollPercent() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    if (docHeight <= 0) return 0;
    return (scrollTop / docHeight) * 100;
  }

  function onScroll() {
    if (getScrollPercent() >= scrollPercent) {
      triggerScroll();
    }
  }

  // --- Don't show if cookie is set ---
  if (getCookie(COOKIE_NAME)) return;

  // --- Trigger logic ---
  function triggerDelay() {
    showPopup();
  }

  function triggerScroll() {
    showPopup();
  }

  // Immediately
  if (triggerMode === "immediately") {
    showPopup();
  }

  // Delay-based modes
  if (triggerMode === "delay" || triggerMode === "delay_or_scroll") {
    setTimeout(triggerDelay, delaySeconds * 1000);
  }

  // Scroll-based modes
  if (triggerMode === "scroll_down" || triggerMode === "delay_or_scroll") {
    window.addEventListener("scroll", onScroll);
  }

  // --- Close events ---
  if (closeBtn) {
    closeBtn.addEventListener("click", hidePopup);
  }
  if (overlay) {
    overlay.addEventListener("click", hidePopup);
  }
});
